export class FilesEntity {
    constructor() {
    }

    public files_id: any = null;
    public files_type: any = null;
    public files_typename: any = null;
    public files_name: any = null;
    public files_url: any = null;
    public files_source: any = null;
    public files_sourceid: any = null;
    public files_date: any = null;
    public files_user: any = null;
    public files_usertype: any = null;


}
